<div class="container mt-3">
<h3>Utskick med misslyckade mail (senaste 2 månaderna)</h3>
   <table class="table table-striped table-hover table-bordered" style="max-height:50%;overflow-y: auto; display:block;">
    <thead>
      <tr>
        <th style="min-width:90px;">Datum</th>
        <th>Ämne</th>
        <th>Institution</th>
        <th>Avsändar-ID</th>
        <th>Avsändarnamn</th>
        <th>Antal mail</th>
        <th>Antal misslyckade mail</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let rowData of data">
        <td style="min-width:60px;">{{ rowData.date | date:'yyyy-MM-dd' }}</td>
        <td>{{ rowData.subject }}</td>
        <td>{{ rowData.institutionShortName }} {{rowData.institutionName }}</td>
        <td>{{ rowData.senderId }}</td>
        <td>{{ rowData.senderName }}</td>
        <td class="text-center">{{ rowData.numberOfRecipients }}</td>
        <td class="text-center">
             <a
                            *ngIf="rowData.numberOfFailedMails > 0"
                            [routerLink]="['/failed-mails', rowData.id]">
                            {{ rowData.numberOfFailedMails }}
                        </a>

                        <span *ngIf="rowData.numberOfFailedMails === 0">
                            {{ rowData.numberOfFailedMails }}
                        </span>
        </td>
      </tr>
    </tbody>
  </table>




  <h4 class="mt-4">Månatlig statistik för misslyckade mail</h4>
   <table class="table table-striped table-hover table-bordered mt-2" style="max-height:50%;overflow-y: auto; display:block;">
    <thead>
      <tr>
        <th style="min-width:90px;">År</th>
        <th>Månad</th>     
        <th>Antal mail</th>
        <th>Antal misslyckade mail</th>
        <th>Felprocent</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let rowData of stats">
        <td style="min-width:60px;">{{ rowData.year }}</td>
        <td class="text-end">{{ rowData.month }}</td>
        <td class="text-end">{{ rowData.totalRecipients }}</td>
        <td class="text-end">{{ rowData.totalFailedMails }}</td>
        <td class="text-end">{{ rowData.failedPercentage}}</td>
      </tr>
    </tbody>
  </table>
</div>
 <!--pre>{{data|json}}</pre-->
